import React, { useState, useEffect } from "react";
import {
  Card,
  Typography,
  makeStyles,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  CardContent,
  Avatar,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  updatePlayWakeup
} from "actions/user.js";
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ElderlyIcon from '@mui/icons-material/Elderly';
import HotelIcon from '@mui/icons-material/Hotel';

import { createTheme } from '@material-ui/core/styles';
import { SIREN_COLOR, SIREN_STATUS_LABEL } from "config.js";
import palette from 'theme/palette';
import { CONFIG_SETTINGS } from 'config.js';

import { styled } from "@material-ui/core/styles";

import firebase from '../../../../Firebase';
import 'firebase/database';
import { deepOrange, deepPurple, green } from '@material-ui/core/colors';
import { useIntl } from "react-intl";

import audioFile from './../../../../assets/sounds/chime.mp3';

import moment from 'moment';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import MoreVertIcon from '@mui/icons-material/MoreVert';

import {
  updateOpenDialog,
  updateSelectedDeviceId,
  updateSelectedDeviceLabel
} from "actions/settings";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));



const CardView = (props) => {
  const { className, history, roomId, roomName, dataList, ...rest } = props;
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const [deviceList, setDeviceList] = useState([]);
  const [audio, setAudio] = useState(new Audio(audioFile));

  const handleExpandClick = (deviceId, installed_pos_detail) => {

    props.updateOpenDialog(true);
    props.updateSelectedDeviceId(deviceId);
    props.updateSelectedDeviceLabel(roomName + ' - ' + installed_pos_detail);
  };


  const sortlist = (list) => {

    let sortable = list.sort(function (a, b) {
      let x = a.installed_pos_detail.toLowerCase();
      let y = b.installed_pos_detail.toLowerCase();

      if (x < y) { return -1; }
      if (x > y) { return 1; }
      return 0;
    });

    return sortable;
  }


  var i = 0;
  let intervalID = 0;
  let playIntervalID = 0;


  var trackLength = 6000;
  var playthroughs = 20; // play max 20 times, 기상은 20번만...


  const flash = () => {
    document.body.style.backgroundColor = (i = ~i) ? '#f89b00' : '#eee6c4';
  }


  const playaudio = () => {

    if (playthroughs > 0) {
      audio.pause();
      audio.currentTime = 0;//play stop

      audio.muted = true;
      audio.play();
      audio.muted = false;
      playthroughs--;
      console.log("playthroughs : ", playthroughs);
    } else {
      playthroughs = 20;
      clearInterval(playIntervalID);
    }

    // //Topbar의 정지 버튼을 누르면, 음악 재생 중지할 것.
    if (localStorage.getItem(CONFIG_SETTINGS.PLAY_WAKEUP_ALARM) == 'false') {
      stopAlarm();
      return;
    }

  }


  const stopAlarm = () => {
    console.log("stopAlarm - wakeup");
    clearInterval(intervalID);
    intervalID = 0;
    document.body.style.backgroundColor = palette.background.default;

    clearInterval(playIntervalID);
    playIntervalID = 0;

    playthroughs = 20;
    audio.currentTime = 0;//play stop
    audio.pause();
  }



  useEffect(() => {

    const alert_Wakeup = localStorage.getItem(CONFIG_SETTINGS.AlertWakeUp);
    const alert_start_time = localStorage.getItem(CONFIG_SETTINGS.Wakeup_Start_Time);
    const alert_end_time = localStorage.getItem(CONFIG_SETTINGS.Wakeup_End_Time);
    const cur_time = moment().format('HH:mm');


    let list = [];
    let list_status = [];

    if (dataList != null) {
      dataList.map(function (data) {

        if (data.deviceId !== null) {

          list_status[data.deviceId] = data.status;

          if (data.facility_id == null || data.facility_id.length == 0) return;

          var dbRef = firebase.database().ref('/dashboard/' + data.facility_id).child("presence");
          dbRef.child(data.deviceId).on('value', (snapshot) => {
            if (snapshot.val()) {
              // console.log("firebase 반영, deviceid: ", data.deviceId + " , status: " + snapshot.val());

              let prevRow = dataList.find(device => device.deviceId === data.deviceId);
              if (prevRow !== null) {

                let target_wakeup = false;

                if (alert_Wakeup === "on") {

                  if (cur_time >= alert_start_time ||
                    cur_time <= alert_end_time) {

                    console.log('기상 알람 대상');

                    localStorage.setItem(CONFIG_SETTINGS.PLAY_WAKEUP_ALARM, 'true');
                    props.updatePlayWakeup(1);

                    target_wakeup = true;
                  }
                }


                if (snapshot.val() === 'WAKEUP') {
                  if (target_wakeup) {

                    intervalID = setInterval(flash, 2000);
                    playIntervalID = setInterval(playaudio, trackLength);
                  }
                } else {
                  if (intervalID > 0) {
                    stopAlarm();
                  }
                }


                prevRow.status = snapshot.val();

                let newlist = dataList.filter(device => device.deviceId !== data.deviceId);
                newlist.push(prevRow);

                setDeviceList(sortlist(newlist));
              }
            }
          });



          //in-bed 표시
          var dbRef2 = firebase.database().ref('/dashboard/' + data.facility_id).child("inbed");
          dbRef2.child(data.deviceId).on('value', (snapshot) => {
            if (snapshot.exists()) {
              let prevRow = dataList.find(device => device.deviceId === data.deviceId);
              if (prevRow !== null) {
                prevRow.inbed = snapshot.val();

                let newlist = dataList.filter(device => device.deviceId !== data.deviceId);
                newlist.push(prevRow);

                setDeviceList(sortlist(newlist));
              }
            }
          });

          list.push({
            deviceId: data.deviceId, installed_pos_detail: data.installed_pos_detail,
            keepOnFall: data.keepOnFall,
            status: data.status
          });

        }
      });//map


      // sortable.map( (row) => {
      //   console.log('정렬1: '+ row.installed_pos_detail);
      // });

      setDeviceList(sortlist(list));
    }

  }, []);


  const getRoomHeaderColor = (list) => {
    const hasStatus = (label) => list.some((d) => d.status && d.status.includes(label));

    // 우선순위: 긴급 > 재실 > 그 외(기본)
    if (hasStatus(SIREN_STATUS_LABEL.EMERGENCY_LABEL_EN)) {
      return SIREN_COLOR.EMERGENCY_BG2_COLOR;
    }
    if (hasStatus(SIREN_STATUS_LABEL.PRESENCE_LABEL_EN)) {
      return SIREN_COLOR.ACTIVITY_BG2_COLOR;
    }
    return null;
  };

  const needsWhiteHeaderText = (list) => {
    const hasStatus = (label) => list.some((d) => d.status && d.status.includes(label));
    return hasStatus(SIREN_STATUS_LABEL.EMERGENCY_LABEL_EN) || hasStatus(SIREN_STATUS_LABEL.PRESENCE_LABEL_EN);
  };

  const getAvatar = (status) => {

    switch (status) {
      case SIREN_STATUS_LABEL.EMERGENCY_LABEL:
      case SIREN_STATUS_LABEL.EMERGENCY_LABEL_EN:
      case SIREN_STATUS_LABEL.FALL_LABEL:
      case SIREN_STATUS_LABEL.FALL_LABEL_EN:
        return (
          <Avatar className={classes.fall_avatar} >
            <NotificationsActiveIcon />
          </Avatar>);


      case SIREN_STATUS_LABEL.CAUTION_LABEL:
      case SIREN_STATUS_LABEL.CAUTION_LABEL_EN:
        return (
          <Avatar className={classes.caution} >
            <NotificationImportantIcon />
          </Avatar>
        );


      case SIREN_STATUS_LABEL.PRESENCE_LABEL:
      case SIREN_STATUS_LABEL.PRESENCE_LABEL_EN:
        return (
          // style={{height:30, width:30}}
          <Avatar className={classes.presence}  >
            <AccessibilityIcon />
          </Avatar>
        );


      case SIREN_STATUS_LABEL.ABSENCE_LABEL:
      case SIREN_STATUS_LABEL.ABSENCE_LABEL_EN:
        return (
          <Avatar className={classes.absence} >
            <RemoveCircleOutlineIcon />
          </Avatar>
        );


      case SIREN_STATUS_LABEL.DEVICE_ERROR_LABEL:
      case SIREN_STATUS_LABEL.DEVICE_ERROR_LABEL_EN:
        return (
          <Avatar className={classes.deviceError} >
            <HelpOutlineIcon />
          </Avatar>
        );

      case SIREN_STATUS_LABEL.WAKEUP_LABEL:
      case SIREN_STATUS_LABEL.WAKEUP_LABEL_EN:
        return (
          <Avatar className={classes.wakeUp} >
            <ElderlyIcon />
          </Avatar>
        );

      default:
        // console.log('Unknown status: ' + status);
        return (
          <Avatar className={classes.absence} >
            <ErrorOutlineIcon />
          </Avatar>
        );
    }
  }

  const isInBed = (bed_label) => {

    if (bed_label === 'INBED') {
      return (
        <Avatar className={classes.inbed} variant="rounded"><HotelIcon /></Avatar>
      )
    } else {
      return (
        <Avatar className={classes.not_inbed} variant="rounded"><HotelIcon /></Avatar>
      )
    }
  }

  const getKeepOnFallAvatar = (keepOnFall) => {
    switch (keepOnFall) {
      case 1:
        return (
          <Avatar className={classes.orange} variant="rounded">M</Avatar>
        );

      default:
        return (
          <Avatar className={classes.purple} variant="rounded">A</Avatar>
        );
    }
  }


  return (

    <div>

      <Card className={classes.root}>

        <CardHeader
          className={classes.title}
          style={{
            backgroundColor: getRoomHeaderColor(deviceList) || SIREN_COLOR.ABSENCE_COLOR,
            ...(needsWhiteHeaderText(deviceList) ? { color: '#fff' } : {}),
          }}
          title={roomName}
          titleTypographyProps={{ color: 'inherit', variant: 'h5' }}
        />

        <CardContent className={classes.cardcontent}>
          <List >
            {deviceList.map((data) => (

              <ListItem className={
                data.status.includes(SIREN_STATUS_LABEL.EMERGENCY_LABEL_EN) ? classes.fall_item :
                  data.status.includes(SIREN_STATUS_LABEL.WAKEUP_LABEL_EN) ? classes.wakeup_item :
                    classes.default_item}
                divider
                key={data.deviceId}>

                <ListItemAvatar style={{ marginRight: '-4px' }}>
                  {getAvatar(data.status)}
                </ListItemAvatar>

                <Typography color="inherit" variant="body2" style={{ fontWeight: 'bold', marginRight: '12px' }}>
                  {data.status === "" ? 'CHECK' : formatMessage({ id: data.status })}
                </Typography>

                <ListItemText primary={
                  <Typography variant="h6" style={{ color: SIREN_COLOR.DARK_GRAY }}>
                    {data.installed_pos_detail}
                  </Typography>
                } />


                {isInBed(data.inbed)}

                <ExpandMore
                  onClick={(e) => handleExpandClick(data.deviceId, data.installed_pos_detail)}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                  {/* <MoreVertIcon /> */}
                </ExpandMore>


                {/* <ListItemText primary={data.installed_pos_detail} primaryTypographyProps={{ variant: 'h6', color:'colorSecondary' }} /> */}

                {/* {getKeepOnFallAvatar(data.keepOnFall)} */}


              </ListItem>
            ))}
          </List>
        </CardContent>

      </Card>
    </div>
  );
}




const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updatePlayWakeup,
      updateOpenDialog,
      updateSelectedDeviceId,
      updateSelectedDeviceLabel
    },
    dispatch
  );
};

let mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CardView);



// const CardContent8Padding = styled(CardContent)(`
//   padding: 20;
//   &:last-child {
//     padding-bottom: 0;
//   }
// `);

const theme = createTheme({
  overrides: {
    MuiCardContent: {
      root: {
        padding: 0,
        "&:last-child": {
          paddingBottom: 0,
        },
      },
    },
  }
})


// default_item / fall_item / wakeup_item 공통 스타일 (중복 제거용)
const itemSpacing = {
  marginTop: 2,
  marginBottom: 2,
};

const alertItem = {
  ...itemSpacing,
  paddingTop: 4,
  paddingBottom: 4,
  borderWidth: 2,
  borderRadius: 5,
  borderStyle: 'inset',
};

const useStyles = makeStyles((theme) => ({
  //cardContent padding 조절
  cardcontent: {
    padding: 2,
    "&:last-child": {
      paddingBottom: 2
    }
  },

  root: {
    // padding: theme.spacing(1),
    // maxHeight: "100%",
    // minHeight: '9vw',
    // minHeight: '180px'
    // minHeight: theme.spacing(10)
    minHeight: 180,
  },
  fullHeightCard: {
    height: "100%",
  },
  title: {
    color: theme.palette.text.primary,
    backgroundColor: '#9E9E9E',
    height: 44,
  },
  itemDivider: {
    // height:50,
  },
  policy: {
    // marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  default_item: {
    ...itemSpacing,
    backgroundColor: theme.palette.background.paper,
  },

  fall_item: {
    ...alertItem,
    backgroundColor: SIREN_COLOR.EMERGENCY_BG3_COLOR,
    borderColor: SIREN_COLOR.EMERGENCY_BG_COLOR,
  },

  wakeup_item: {
    ...alertItem,
    backgroundColor: SIREN_COLOR.WAKEUP_BG3_COLOR,
    borderColor: SIREN_COLOR.WAKEUP_BG2_COLOR,
  },

  fall_avatar: {
    backgroundColor: SIREN_COLOR.EMERGENCY_BG3_COLOR,
  },
  caution: {
    backgroundColor: SIREN_COLOR.CAUTION_BG2_COLOR,
  },

  presence: {
    backgroundColor: SIREN_COLOR.ACTIVITY_BG2_COLOR,
  },
  absence: {
    backgroundColor: SIREN_COLOR.ABSENCE_BG2_COLOR,
  },
  wakeUp: {
    backgroundColor: SIREN_COLOR.WAKEUP_BG2_COLOR,
  },
  deviceError: {
    backgroundColor: SIREN_COLOR.DEVICE_ERROR_COLOR,
  },
  unknwon: {
    backgroundColor: SIREN_COLOR.ABSENCE_BG2_COLOR,
  },

  inbed: {
    backgroundColor: "#4a8ede",
    width: 30,
    height: 30,
    // width: '100%',
    // height: '100%',
  },
  not_inbed: {
    // backgroundColor: "#c9cace",
    backgroundColor: SIREN_COLOR.ABSENCE_BG2_COLOR,
    width: 30,
    height: 30,
    // width: '100%',
    // height: '100%',
  },

  orange: {
    // color: '#fff',
    // backgroundColor: green[400],

    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[300],

    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[400]),
    backgroundColor: deepPurple[300],
    width: theme.spacing(3),
    height: theme.spacing(3),
  },

}));